import React from 'react';
import { Drawer as MuiDrawer, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

import CommonIconButton from '../../../../../components/common-icon-button/CommonIconButton';
import { ICONS } from '../../../../../icons';
import SessionHistoryContent from '../session-history-content/SessionHistoryContent';

import scss from './SessionHistoryDrawer.module.scss';

function SessionHistoryDrawer({ isOpen, onClose, isAdmin, onSelectSession, onChangePage }) {
  const { t } = useTranslation('story');

  return (
    <Drawer open={isOpen} hidden={!isOpen} anchor='right' onClose={onClose} variant='temporary'>
      <div className={scss.header}>
        <h3 className={scss.title}>{t('sessionHistory')}</h3>
        <CommonIconButton icon={ICONS.Cross} onClick={onClose} className={scss.closeButton} isStrokeIcon />
      </div>

      <div className={scss.body}>
        <SessionHistoryContent
          isAdmin={isAdmin}
          onSelectSession={onSelectSession}
          onChangePage={onChangePage}
          showTitle={false}
          className={scss.drawerContent}
        />
      </div>
    </Drawer>
  );
}

export default SessionHistoryDrawer;

const Drawer = styled(MuiDrawer)({
  '& .MuiDrawer-paper': {
    background: 'var(--sidebar-bg)',
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
    padding: '0 1rem 1rem',
    width: 'min(400px, 100vw)',
    display: 'flex',
    flexFlow: 'column',
    minHeight: 0,
  },
  '& .MuiBackdrop-root': {
    opacity: '0 !important',
  },
});
